/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsDuplicateUser
 */
export interface MelcoModelsDuplicateUser {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDuplicateUser
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDuplicateUser
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDuplicateUser
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDuplicateUser
     */
    source_user_id?: string | null;
}

export function MelcoModelsDuplicateUserFromJSON(json: any): MelcoModelsDuplicateUser {
    return MelcoModelsDuplicateUserFromJSONTyped(json, false);
}

export function MelcoModelsDuplicateUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDuplicateUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'source_user_id': !exists(json, 'source_user_id') ? undefined : json['source_user_id'],
    };
}

export function MelcoModelsDuplicateUserToJSON(value?: MelcoModelsDuplicateUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_name': value.user_name,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'source_user_id': value.source_user_id,
    };
}


